import React from "react";
import Modal from "react-modal";
import ReactPlayer from "react-player";
const audioPath = process.env.PUBLIC_URL + "/mov_bbb.mp4";

export const VideoModal = ({ isOpen, closeModal }) => {
  const handleClose = () => {
    closeModal();
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      appElement={document.querySelector("#root")}
      overlayClassName={`prp-form__overlay`}
      className="testimonial-video-modal"
    >
      <ReactPlayer
        url="https://youtu.be/LACbVhgtx9I?si=qOMLgsV9Y_QtNPKL"
        controls={false}
        playing
        config={{
          file: {
            attributes: {
              onContextMenu: (e) => e.preventDefault()
            }
          }
        }}
        width="100%"
      />
    </Modal>
  );
};
